export default "__VITE_ASSET__Clrd1xkA__"